<template>
    <span class="waimai-tag" :style="styleColor">
        {{ this.txt }}
    </span>
</template>
<script>
import { colors } from "@/utils/js/colors.js";
import { mapGetters } from "vuex";
export default {
    name: "Tag",
    props: [
        "txt", //背景色
        "plain", //三角形颜色
    ],
    computed: {
        ...mapGetters(["eventData"]),
        styleColor() {
            let style = {
                borderColor: colors[this.eventData.tenant_code]
            }
            if(!this.plain) {
                style = {
                    ...this.style,
                    background: colors[this.eventData.tenant_code],
                }
            } else {
                style = {
                    ...this.style,
                    color: colors[this.eventData.tenant_code]
                }
            }
            return style
        },
        triangle() {
            let style = {
                borderColor: colors[this.eventData.tenant_code]
            }
            return style
        }
    },
};
</script>
<style lang="scss">
.waimai-tag {
    position: relative;
    border: 0.01rem solid;
    display: inline-block;
    border-radius: 0.05rem;
    font-size: 0.1rem;
    padding: 0.01rem;
    padding-right: 0.1rem;
    color: #fff;
    margin-right: 0.08rem;

    
}
.waimai-tag:after {
        content: ' ';
        height: 0.08rem;
        width: 0.08rem;
        position: absolute;
        transform: rotate(-45deg);
        background: #fff;
        top: 0.045rem;
        right: -0.045rem;
    }
</style>